import { makeObservable, observable, runInAction } from "mobx";
import { Model, getPublicVotings, ApiVotingListItem, VOTING_STATUSES } from "@lubbezposrednio-frontend/core";

export class HomeViewModel extends Model {
  // zapisy otwarte — vox populi, do których gość MOŻE się teraz zapisać (najważniejsze dla odwiedzającego)
  openSignups: ApiVotingListItem[] = [];
  // referenda otwarte — głosowania, w których może wziąć udział każdy zweryfikowany
  openVotings: ApiVotingListItem[] = [];
  isLoading = true;

  constructor() {
    super();

    makeObservable(this, {
      openSignups: observable,
      openVotings: observable,
      isLoading: observable
    });
  }

  override async onInit() {
    try {
      const [plannedRes, ongoingRes] = await Promise.all([
        getPublicVotings({ per_page: 24, status: [VOTING_STATUSES.PLANNED] }),
        getPublicVotings({ per_page: 24, status: [VOTING_STATUSES.ONGOING] })
      ]);

      const planned = (plannedRes.data.votings as ApiVotingListItem[]) ?? [];
      const ongoing = (ongoingRes.data.votings as ApiVotingListItem[]) ?? [];

      runInAction(() => {
        this.openSignups = planned.filter(v => v.signup_open).slice(0, 6);
        this.openVotings = ongoing.filter(v => v.electorate_type === "open").slice(0, 6);
      });
    } catch (error) {
      console.error("[HomeViewModel] nie udało się pobrać głosowań", error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }
}
